export default __webpack_public_path__ + "static/media/customers-7.be494440.jpg";